import { message } from 'antd';
import { useMemo } from 'react';
import { Menu, Item, useContextMenu as useMenu } from 'react-contexify';
import { useTranslate } from '@tolgee/react';

const contextMenuId = '@@messageEditorContextMenu';

export interface ContextMenuProps {
  onPasteText: (text: string) => void;
  onPasteFile: (files: File[]) => void;
}

function ContextMenu(props: ContextMenuProps) {
  const { onPasteText, onPasteFile } = props;

  const { t } = useTranslate();

  return (
    <Menu id={contextMenuId}>
      <Item
        onClick={() => {
          try {
            const text = window.getSelection()?.toString();
            navigator.clipboard.writeText(text || '');
          } catch (err) {
            message.error(t('ViewsChat.复制失败'));
          }
        }}
      >
        {t('ViewsChat.复制')}
      </Item>
      <Item
        onClick={() => {
          navigator.clipboard
            .readText()
            .then(onPasteText)
            .catch(() => {});

          (navigator.clipboard as any)
            .read()
            .then((items: any[]) => {
              items
                .reduce<Promise<File[]>>((res, item) => {
                  return res
                    .then((files) => {
                      const { types = [] } = item || {};

                      const imageType = (types as string[]).find((type) => {
                        return type.startsWith('image');
                      });

                      if (!imageType) {
                        return files;
                      }

                      return item.getType(imageType).then((blob: any) => {
                        const file = new File([blob], 'image.png', {
                          lastModified: Date.now(),
                          type: 'image/png',
                        });

                        files.push(file);

                        return files;
                      });
                    })
                    .catch(() => []);
                }, Promise.resolve([]))
                .then(onPasteFile)
                .catch(() => {});
            })
            .catch(() => {});
        }}
      >
        {t('ViewsChat.粘贴')}
      </Item>
    </Menu>
  );
}

export function useContextMenu(props: ContextMenuProps) {
  const { show: showContextMenu } = useMenu({
    id: contextMenuId,
  });

  const contextMenu = useMemo(() => <ContextMenu {...props} />, [props]);

  return {
    showContextMenu,
    contextMenu,
  };
}

export default ContextMenu;
